import { lazy } from "react";
import { Route } from "react-router-dom";
import Layout from "../../components/PageNavigation/Layout";

const MaintenanceGuidePage = lazy(() =>
  import("./pages/MaintenanceGuidePage")
);

// Export individual routes, not a component wrapper
export const maintenanceGuideRoutes = [
  <Route
    key="maintenance-guide"
    path="/maintenance-guide"
    element={
      <Layout>
        <MaintenanceGuidePage />
      </Layout>
    }
  />,
  // Add future routes here as more array items
  // <Route key="maintenance-guide-detail" path="/maintenance-guide/:id" element={<Layout><MaintenanceDetailPage /></Layout>} />,
];